<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
  
<tr max-height="48px" height="48px"> 
<ContenidoBase 
  :titulo="'CERTIFICADO DE INSCRIPCION DE SUSTANCIAS CONTROLADAS'"
  :descripcion="'Clase B'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="NotifMessage"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"    
/>
    </tr>

  
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <!-- <v-btn-toggle></v-btn-toggle> -->
                <v-btn
                width="95%"
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                
              
            </center>
            <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitSaludCertificadoInsc'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            />
          </template>
        </v-tooltip>




      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 
 
 <v-card color="grey lighten-3">
<div style="border: 1px solid #000000;">
  <span class="pa-2" > FROM DNCD-QP005-v2</span><br>
  <span class="pa-2" >LEY 50-88</span>

  <center>
  <b>Reppública Dominicana</b>
  <b></b>
  <h4>Presidencia de la República</h4>
  <h2>SOLICITUD</h2>
  </center>
    <span class="d-flex justify-end pa-2">No. CIDC</span>

<center>
  <span>CERTIFICADO DE INSCRIPCION DE SUSTANCIAS CONTROLADAS</span>
  <h3>- CLASE B -</h3>

</center>

</div>
 </v-card>
 



 <v-container>

 <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
<v-card-actions style="border: 1px solid #000000;" class="d-flex justify-center" >
      INDENTIFICACION
  </v-card-actions>

  <v-card color="grey lighten-3">
  <v-container style="border: 1px solid #000000;" >
  
              <v-row>

                <v-col cols="12" md="12" sm="12">

                <!-- ----------------------------- Nombre -->
                  <v-text-field
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    autocomplete="off"
                    label="1) Nombre de empresa / Razón Social:"
                    required
                    outlined
                    dense
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-font"></i>
                    </template>
                  </v-text-field>

                  <!-- ----------------------------- direccion -->
                  <v-textarea
                  autocomplete="off"
                    label="2) Dirección/Correo postal (P.O.B):"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    rows="3"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-map-marker"></i>
                    </template>
                  </v-textarea>
                </v-col>

<v-container style="margin-top:-40px;" >
                <v-row  >
                <v-col cols="12" md="4" sm="4">
                  <!-- ----------------------------- teléfono -->
            <v-text-field
            label="3) teléfono:"
            dense
            outlined
            autocomplete="off"
           
            maxlength="13"
            v-mask="'(###)###-####'"
            v-model="Certificado.descripcion"
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-phone"></i>
            </template> 
          </v-text-field>
                </v-col>

                <v-col cols="12" md="4" sm="4">
                  <!-- -----------------------------  email -->
             <v-text-field label="4) Email:"
                     dense outlined
                     v-model="Certificado.descripcion"
                      
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-envelope-o"></i> 
                      </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" md="4" sm="4">

                  <!-- -----------------------------rnc --> 
                
                  <v-text-field 
                  autocomplete="off"
                    v-mask="'###-#####-#'"
                    label="5) RNC:"
                    dense
                    outlined
                    maxlength="11"
                    :rules="[$rules.RulesRnc]"
                    v-model="Certificado.descripcion"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-id-card-o"></i>
                    </template>
                  </v-text-field>

                </v-col>
              </v-row>
</v-container>

              </v-row> 
       </v-container>
  </v-card>

  <v-card color="grey lighten-3">
  <v-container style="border: 1px solid #000000;">

<v-row>
<v-col cols="12" md="6" sm="6">
  <span>6) ACTIVIDAD(ES)</span>
<v-radio-group v-model="Certificado.opcion" column > 
<v-radio label="Importadora" color="green" :value="1"></v-radio>
<v-radio label="Exportadora" color="green" :value="2"></v-radio>
<v-radio label="Fabricante" color="green" :value="3"></v-radio>
<v-radio label="Distribuidor" color="green" :value="4"></v-radio>
<v-radio label="Laboratorio análitico" color="green" :value="5"></v-radio>
<v-radio label="Clínica privada" color="green" :value="6"></v-radio>
<v-radio label="Institución de enseñanza superior" color="green" :value="7"></v-radio>
<v-radio label="Investigación Categoría" color="green" :value="9"></v-radio>
<v-radio label="Otra, especifique" color="green" :value="10"></v-radio>
</v-radio-group>
 

</v-col>

<v-col cols="12" md="6" sm="6">
<span>7) ESTATUS</span>

<v-radio-group v-model="Certificado.opcion" column > 
<v-radio label="a) Primera solicitud" color="green" :value="1"></v-radio>
<v-radio label="b) Renovación" color="green" :value="2"></v-radio>
<v-radio label="c) Solicitud anterior negada" color="green" :value="3"></v-radio>
<v-radio label="d) CIDC reprobado, suspendido" color="green" :value="4"></v-radio>
<v-radio label="e) Otra, especifique" color="green" :value="5"></v-radio>
</v-radio-group>



</v-col>

    </v-row>

  </v-container>
  </v-card>

  <v-card-actions style="border: 1px solid #000000;" class="d-flex justify-center" >
      REGENTE FARMACEUTICO
  </v-card-actions>

<v-card color="grey lighten-3">
  <v-container style="border: 1px solid #000000;" >
  
              <v-row>

                <v-col cols="12" md="12" sm="12">

                <!-- ----------------------------- Nombre -->
                  <v-text-field
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    autocomplete="off"
                    label="8) Nombre del Regente:"
                    required
                    outlined
                    dense
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-font"></i>
                    </template>
                  </v-text-field>

                <v-row>
                  <v-col cols="12" md="6" sm="6" >
                  <!-- ----------------------------- direccion -->
                  <v-textarea
                  autocomplete="off"
                    label="9) Dirección:"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    rows="2"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-map-marker"></i>
                    </template>
                  </v-textarea>
                  </v-col>

                  <v-col cols="12" md="6" sm="6" >
                  <!-- ----------------------------- direccion -->
                  <v-textarea
                  autocomplete="off"
                    label="10) Otro lugar de trabajo:"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    rows="2"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-building-o"></i>
                    </template>
                  </v-textarea>
                  </v-col>
              </v-row>



                </v-col>




<v-container style="margin-top:-40px;" >
                <v-row  >
                <v-col cols="12" md="4" sm="4">
                  <!-- ----------------------------- teléfono -->
            <v-text-field
            label="11) teléfono:"
            dense
            outlined
            autocomplete="off"
           
            maxlength="13"
            v-mask="'(###)###-####'"
            v-model="Certificado.descripcion"
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-phone"></i>
            </template> 
          </v-text-field>
                </v-col>

                <v-col cols="12" md="4" sm="4">
             <!-- ------------------------------- exequatur -->
                    <v-text-field
                      autocomplete="off"
                      label="14) No. exequátur"
                      v-model="Certificado.descripcion"
                      required
                      outlined
                      dense
                    >
                      <template v-slot:prepend>
                        <vue-fontawesome
                          icon="id-badge"
                          size="1.5"
                          color="black"
                        ></vue-fontawesome>
                      </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" md="4" sm="4">

                  <!-- -----------------------------rnc --> 
                
                  <!-- ----------------------------------------- cedula  -->
<v-text-field
            v-mask="'###-#######-#'"
            label="15) Cédula:"
            autocomplete="off"
            dense
            outlined
            maxlength="13"
            :rules="[$rules.required, $rules.RulesCel]"
            v-model="Certificado.descripcion"
          >
          
              <template v-slot:prepend>
                <i style="font-size: 20px;" class="fa fa-id-card-o"></i>
              </template>
       
          </v-text-field>

                </v-col>
              </v-row>
</v-container>

              </v-row> 
       </v-container>
  </v-card>

<v-card color="grey lighten-3">
  <v-container style="border: 1px solid #000000;">
    <v-col cols="12" md="12" sm="12">

      <!-- -----------------------------  fecha  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="14) Fecha solicitud:"
        v-model="Certificado.fecha"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
  
</v-text-field>

<!-- ----------------------------- firma -->
                  <v-text-field
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    autocomplete="off"
                    label="15) Firma interezado:"
                    required
                    outlined
                    dense
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-pencil-square"></i>
                    </template>
                  </v-text-field>

<!-- ----------------------------- firma -->
                  <VueAutonumeric
                      label="16) SUMA A PAGAR RD$:"
                      autocomplete="off"
                      style="font-size: 13px;"
                      required
                      outlined
                      dense
                      v-model="Certificado.descripcion"
                     :rules="[$rules.required, $rules.porciento]"
                    >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-money"></i>
                      </template>
                    </VueAutonumeric>

    </v-col>
  </v-container> 
  </v-card>

<v-card color="grey lighten-3">
  <v-container style="border: 1px solid #000000;">
<center>
    <b>Solo para uso interno</b>
</center>
    <v-row>
      <!-- columna 1----------------------------- -->
      <v-col cols="12" md="4" sm="4">
         <!-- -----------------------------  fecha  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha aprobado:"
        v-model="Certificado.fecha"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
  
</v-text-field>
      </v-col>
      <!-- fn columna 1 ----------------------------->

      <!-- columna 2 ------------------------------------------>
      <v-col cols="12" md="4" sm="4">
        <!----------------------------------------------------- No. Factura -->
<v-text-field
                      :rules="[$rules.required]"
                      label="No. Factura"
                      required
                      outlined
                      dense
                      v-model="Certificado.descripcion"
                    >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-hashtag"></i>
                      </template>
                    </v-text-field>
      </v-col>
      <!-- fn columna 2 ---------------------------------->
      <!-- columna 3 -------------------------------------->
      <v-col cols="12" md="4" sm="4">

         <!-- -----------------------------  fecha  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha pago:"
        v-model="Certificado.fecha"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
  
</v-text-field>
        
      </v-col>
      <!-- fn columna 3 ------------------------------- -->

    </v-row>

  </v-container>
</v-card>


<v-card color="grey lighten-3">

  <v-container style="border: 1px solid #000000;">
    

  <v-row>

<!-- columna 1 -------------------------------->
    <v-col cols="12" md="6" sm="6">

<span>17) Categorías de Drogas Controladas que Solicita:</span>
      <v-radio-group v-model="Certificado.opcion" row>   
                  <v-radio label="II" color="yellow accent-4" :value="1"></v-radio>
                  <v-radio label="III" color="green " :value="2"></v-radio>
                  <v-radio label="IV" color="red" :value="3"></v-radio>                                
              </v-radio-group>

    </v-col>
    <!-- fn columna 1 ------------------------>
<!-- columna 2 ------------------------------->
    <v-col cols="12" md="6" sm="6">

      <!-- ----------------------------- Motivo de la reunión -->
                  <v-textarea
                  autocomplete="off"
                    label="18) Código de las Drogas de categorías II, II, IV:"
                    rows="2"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-superpowers"></i>
                    </template>
                  </v-textarea>

    </v-col>

    <!-- fn columna 2 -------------------------->

  </v-row>




  </v-container>

  </v-card>

<v-card color="grey lighten-3">
<v-container style="border: 1px solid #000000;">
    <v-col cols="12" sm="12" md="12" >

<!-- ----------------------------- sustancias -->
                  <v-textarea
                  autocomplete="off"
                    label="Desglose de sustancias controladas:"
                    rows="2"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-superpowers"></i>
                    </template>
                  </v-textarea>

</v-col>
    
</v-container>
</v-card>
<v-card-actions style="border: 1px solid #000000;" class="d-flex justify-center" >
      ADMINISTRADOR / PROPIETARIO
</v-card-actions>

<v-card color="grey lighten-3">
<v-container style="border: 1px solid #000000;">
<v-row>


<!-- ----------------------------- Nombre -->
<v-col cols="12" md="12" sm="12" >
                  <v-text-field
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    autocomplete="off"
                    label="25) Nombre del agente aduanero:"
                    required
                    outlined
                    dense
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-font"></i>
                    </template>
                  </v-text-field>

</v-col>

                
                  <v-col cols="12" md="6" sm="6" >
                  <!-- ----------------------------- direccion -->
                  <v-textarea
                  autocomplete="off"
                    label="26) Dirección:"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    rows="2"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-map-marker"></i>
                    </template>
                  </v-textarea>
                  <!-- ----------------------------- teléfono -->
                    <v-text-field
                    label="27) teléfono:"
                    dense
                    outlined
                    autocomplete="off"
                  
                    maxlength="13"
                    v-mask="'(###)###-####'"
                    v-model="Certificado.descripcion"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-phone"></i>
                    </template> 
                  </v-text-field>
                  

                  </v-col>

                  <v-col cols="12" md="6" sm="6" >
                  <!-- ----------------------------- direccion -->
                  <v-textarea
                  autocomplete="off"
                    label="28) Otro lugar de trabajo:"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    rows="2"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-building-o"></i>
                    </template>
                  </v-textarea>

                  <!-- ----------------------------------------- cedula  -->
<v-text-field
            v-mask="'###-#######-#'"
            label="29) Cédula:"
            autocomplete="off"
            dense
            outlined
            maxlength="13"
            :rules="[$rules.required, $rules.RulesCel]"
            v-model="Certificado.descripcion"
          >
          
              <template v-slot:prepend>
                <i style="font-size: 20px;" class="fa fa-id-card-o"></i>
              </template>
       
          </v-text-field>



                  </v-col>  
                
              </v-row>

</v-container>
</v-card>

<v-card-actions style="border: 1px solid #000000;" class="d-flex justify-center" >
      DETALLES C,D,y E
</v-card-actions>

<v-card color="grey lighten-3">
<v-container style="border: 1px solid #000000;">
<v-col cols="12" md="12" sm="12" >
<v-textarea
                  autocomplete="off"
                    label="RENGLON No. 8:"
                    dense
                    outlined
                    v-model="Certificado.descripcion"
                    :rules="[$rules.required]"
                    rows="2"
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-caret-square-o-up"></i>
                    </template>
                  </v-textarea>
  </v-col>
</v-container>

</v-card>




  </v-form>
 </v-container>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-tooltip top>
<template v-slot:activator="{ on }"> 
  <v-btn v-on="on"
                dark
                  small
                  color="deep-purple accent-2"
                  @click.prevent=""
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn>

 </template>
          <span>Imprimir Listado</span>
        </v-tooltip>




          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ notif-->
    <v-dialog
      label="myAlert"
      v-model="notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            v-if="notif.Exec=='eliminarCertificado'"
            @click.prevent="eliminar(), (notif.estado = !notif.estado)"
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          

          <v-btn @click.prevent="notif.estado = !notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->


    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import VueAutonumeric from "../../components/AutoNumericNuevo";
import ContenidoBase from "../../components/ContenidoBase";
export default {
  components: {
    BarraBusqueda2,
    VueAutonumeric,
    ContenidoBase 
  },
  created() {
    var json = {
      titulo: "CERTIFICADO DE INSCRIPCION DE SUSTANCIAS CONTROLADAS",
      descripcion: "Clase B",
      save: true,
      eliminar: true,
      anular: false,
      nuevo: true,
      imprimir: true,
      accion: [ 
        "SaludCertificadoInscNew",
        "SaludCertificadoInscSave",
        "SaludCertificadoInscRemove",
        "SaludCertificadoInscAnular",
        "SaludCertificadoInscPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("SaludCertificadoInscNew", this.new);
    // EventBus.$on("SaludCertificadoInscSave", this.save);
    // EventBus.$on("SaludCertificadoInscRemove", this.remove);
    // EventBus.$on("SaludCertificadoInscAnular", this.remove);
    // EventBus.$on("SaludCertificadoInscPrintList", this.imprimirList);
    EventBus.$on("emitSaludCertificadoInsc", this.datostabla);
    this.cargarTodo();

    EventBus.$on("onResize", this.onResize);
  },

  data() {
    return {
      ListaTiposClientes: [],
      windowSize:{width:"auto", height:"auto"},
      Certificado: {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        opcion:1,
        fecha: new Date().toISOString().substr(0,10)
       
      },

EstadoBtn:{ 
        BarraTablaDinamicaAprir:true,
        nuevo:true,
        guardar:true,
        eliminar:false,
        anular:false,
        imprimir:true,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        etiquetaXfactura:false
        },

     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      notif: {
        estado: false,
        nombre: "",
        Exec:""
      },

      aalert: {
        estado: false,
        color: null
      },
    
    };
  },

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {

onResize(e){

console.log("imprii ")

console.log(e)
this.windowSize=e


},



    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },
    async cargarTodo() {
      await this.$axios
        .post(
          this.$hostname +
            this.$hName +
            "/services/tipocliente/findalltipoclientes",
          {
            usuario:JSON.parse(JSON.stringify(this.$user)) 
          }
        )
        .then(res => (this.ListaTiposClientes = res.data))
        .catch(error => console.log(error));
    },
    datostabla(e) {

      this.Certificado = e;
      this.acti_tb_data=false
    },
    save() {

if (this.$refs.form.validate()) {

      var jsn={
   datos:JSON.parse(JSON.stringify(this.Certificado)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }
      this.$axios
        .post(
          this.$hostname +
            this.$hName +
            "/services/tipocliente/saveTipoCliente",
          JSON.parse(JSON.stringify(jsn))
        )
        .then(res => this.alerta("Dato guardado correctamente!", "bien"))
        .catch(error =>
          this.alerta("Dato no guardado","error"
            // "hubo un error , por favor verifique el campo descripcion!",
            // "error"
          )
        );
}else{
this.alerta("Los campos en rojo son requeridos", "error");
}




    },


NotifMessage() {

if(this.Certificado.codigo!=0 && this.Certificado.codigo!=null){

var notif= {
        estado: true,
        nombre: "¿Seguro que desea eliminar este registro?",
        Exec:"eliminarCertificado"
      }

this.Exec_notif(notif)

     
}else{ this.alerta("Seleccione una certificacion para eliminar", "error")}


    },

 Exec_notif(e) {

//console.log(e)
this.notif=JSON.parse(JSON.stringify(e))

//this.Elim_notif.estado = !this.Elim_notif.estado;
    },




    eliminar() {

  var jsn={
   datos:JSON.parse(JSON.stringify(this.Certificado)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }

if (this.Certificado.codigo!=0) {
        this.$axios
          .post(
            this.$hostname +
              this.$hName +
              "/services/tipocliente/borradoTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => {this.alerta(res.data.mensage, res.data.estado)  })
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }


    },
    anular() {
      // if (this.Elim_notif.estado) {}

var jsn={
   datos:JSON.parse(JSON.stringify(this.Certificado)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }

        this.$axios
          .post(
            this.$hostname +
              this.$hName +
              "/services/tipocliente/removeTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => this.alerta("Dato eliminado correctamente!", "bien"))
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      
    },
    imprimirList() {},
    newwnuevo() {
      (this.Certificado = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario:JSON.parse(JSON.stringify(this.$user)) 
        })
        .then(res => {
          this.list = res.data;
        });
    }
  },

computed:{

    ActDescBtn(){      
if(this.Certificado.codigo>0){

this.EstadoBtn={ 
        BarraTablaDinamicaAprir:true,
        nuevo:true,
        guardar:true,
        eliminar:true,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        etiquetaXfactura:false
        }
}


if(this.Certificado.codigo<=0){
this.EstadoBtn={ 
        BarraTablaDinamicaAprir:true,
        nuevo:true,
        guardar:true,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        etiquetaXfactura:false
        }
}

    }
    }

  
};
</script>

<style></style>
